(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  let productZoomObserverStarted = false;

  function applyProductZoomStyles() {
    const configEl = document.querySelector('[data-product-zoom-config]');
    if (!configEl) {
      return;
    }

    const zoomBgClass = configEl.dataset.zoomBg;
    if (!zoomBgClass) {
      return;
    }

    const zoomBgCompose = `product-zoom-bg--${zoomBgClass}`;
    const fancyboxContainer = document.querySelector('.fancybox__container');

    if (fancyboxContainer && !fancyboxContainer.classList.contains(zoomBgCompose)) {
      fancyboxContainer.classList.add(zoomBgCompose);
    }
  }

  function initProductZoomStyles() {
    applyProductZoomStyles();

    if (!productZoomObserverStarted) {
      const observer = new MutationObserver((mutations) => {
        applyProductZoomStyles();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      productZoomObserverStarted = true;
    }
  }

  document.addEventListener('DOMContentLoaded', initProductZoomStyles);
  document.addEventListener('shopify:section:load', initProductZoomStyles);

  document.addEventListener('click', function () {
    setTimeout(applyProductZoomStyles, 50);
    setTimeout(applyProductZoomStyles, 150);
    setTimeout(applyProductZoomStyles, 300);
  });

  } catch(e) { console.error(e); }
})();
})();
